import React from 'react';

export const Layout = ({
  Component,
  ...pageProps
}: {
  Component: React.ComponentType;
}) => (
  <div className="bg-semi-color-tertiary-light-default min-w-screen min-h-screen">
    <Component {...pageProps} />
  </div>
);

export default Layout;
